export const REQ_LOGIN_DATA = 'REQ_LOGIN_DATA';
export const REQ_LOGIN_DATA_SUCCESS = 'REQ_LOGIN_DATA_SUCCESS';
export const REQ_LOGIN_DATA_FAIL = 'REQ_LOGIN_DATA_FAIL';

export const EMAIL_DOES_NOT_EXIST = 'EMAIL_DOES_NOT_EXIST';
export const EMAIL_EXISTS = 'EMAIL_EXISTS';
export const EMAIL_VERIFICATION_PENDING = 'EMAIL_VERIFICATION_PENDING';
export const EMAIL_ERROR = 'EMAIL_ERROR';

export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNIN_FAIL = 'SIGNIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const OTP_SENT_ERROR = 'OTP_SENT_ERROR';

export const OTP_SENT_TO_RESET_PASSWORD = 'OTP_SENT_TO_RESET_PASSWORD';
export const OTP_VERIFICATION_SUCCESS = 'OTP_VERIFICATION_SUCCESS';
export const OTP_VERIFICATION_FAIL = 'OTP_VERIFICATION_FAIL';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';

export const ORDER_DATA_FOUND = 'ORDER_DATA_FOUND';
export const NO_ORDER_DATA_FOUND = 'NO_ORDER_DATA_FOUND';
export const ORDER_ERR = 'ORDER_ERR';

export const USER_DATA_FOUND = 'USER_DATA_FOUND';
export const USER_DATA_ROLE = 'USER_DATA_ROLE';
export const USER_DATA_RESET = 'USER_DATA_RESET';

export const REQUEST_USER_LIST_SUCCESS = 'REQUEST_USER_LIST_SUCCESS';
export const TEST_MODE = 'TEST_MODE';
export const LIVE_MODE = 'LIVE_MODE';

export const SERVER_ERROR = 'SERVER_ERROR';
export const GET_MERCHANT_ID = 'GET_MERCHANT_ID';

export const TRANSACTIONS_DATA_FOUND = 'TRANSACTIONS_DATA_FOUND';
export const TRANSACTIONS_DATA_ERROR = 'TRANSACTIONS_DATA_ERROR';

export const CUSTOMERS_DATA_FOUND = 'CUSTOMERS_DATA_FOUND';
export const CUSTOMERS_DATA_ERROR = 'CUSTOMERS_DATA_ERROR';

export const ROLES_DATA_FOUND = 'ROLES_DATA_FOUND';
export const ROLES_DATA_ERROR = 'ROLES_DATA_ERROR';
export const NEW_ROLE_ADD_SUCCESS = 'NEW_ROLE_ADD_SUCCESS';
export const NEW_ROLE_ADD_ERROR = 'NEW_ROLE_ADD_ERROR';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_ERROR = 'UPDATE_ROLE_ERROR';

export const PERMISSIONS_DATA_FOUND = 'PERMISSIONS_DATA_FOUND';
export const PERMISSIONS_DATA_ERROR = 'PERMISSIONS_DATA_ERROR';
export const NEW_PERMISSION_ADD_SUCCESS = 'NEW_PERMISSION_ADD_SUCCESS';
export const NEW_PERMISSION_ADD_ERROR = 'NEW_PERMISSION_ADD_ERROR';

export const PAYMENT_INTERFACE_DATA_FOUND = 'PAYMENT_INTERFACE_DATA_FOUND';
export const PAYMENT_INTERFACE_DATA_ERROR = 'PAYMENT_INTERFACE_DATA_ERROR';

export const MERCHANT_LIST_FOUND = 'MERCHANT_LIST_FOUND';

export const ADDRESS_ANNOTATION_FOUND = 'ADDRESS_ANNOTATION_FOUND';
export const ADDRESS_ANNOTATION_RESET_DATA = 'ADDRESS_ANNOTATION_RESET_DATA';
export const ADDRESS_ANNOTATION_NO_DATA_FOUND = 'ADDRESS_ANNOTATION_NO_DATA_FOUND';
export const ADDRESS_ANNOTATION_ERR = 'ADDRESS_ANNOTATION_ERR';

export const PAYMENT_PROVIDERS_FOUND = 'PAYMENT_PROVIDERS_FOUND';


export const UTM_LIST_FOUND = 'UTM_LIST_FOUND';
export const UTM_LIST_NOT_FOUND = 'UTM_LIST_NOT_FOUND';
export const UTM_LIST_ERROR = 'UTM_LIST_ERROR';